/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { EnMetricContext } from './en-metric-context';
import { EnMetricDistrict } from './en-metric-district';
import { EnMetricMeasure } from './en-metric-measure';
import { EnMetricMovement } from './en-metric-movement';
import { EnMetricSide } from './en-metric-side';
 /**
 *
 *
 * @export
 * @interface MetricRequestDto
 */
export interface MetricRequestDto {

    /**
     * @type {string}
     * @memberof MetricRequestDto
     */
    from: string;

    /**
     * @type {string}
     * @memberof MetricRequestDto
     */
    to: string;

    /**
     * Filter by one or more measures.
     *
     * @type {Array<EnMetricMeasure>}
     * @memberof MetricRequestDto
     */
    measure?: Array<EnMetricMeasure>;

    /**
     * @type {Array<string>}
     * @memberof MetricRequestDto
     */
    aggregations: Array<MetricRequestDtoAggregationsEnum>;

    /**
     * @type {string}
     * @memberof MetricRequestDto
     */
    interval?: string;

    /**
     * @type {string}
     * @memberof MetricRequestDto
     */
    query?: string;

    /**
     * @type {EnMetricContext}
     * @memberof MetricRequestDto
     */
    context?: EnMetricContext;

    /**
     * Filter by one or more anatomical districts.
     *
     * @type {Array<EnMetricDistrict>}
     * @memberof MetricRequestDto
     */
    district?: Array<EnMetricDistrict>;

    /**
     * Filter by body side.
     *
     * @type {EnMetricSide}
     * @memberof MetricRequestDto
     */
    side?: EnMetricSide;

    /**
     * Filter by one or more movement directions.
     *
     * @type {Array<EnMetricMovement>}
     * @memberof MetricRequestDto
     */
    movement?: Array<EnMetricMovement>;
}

/**
 * @export
 * @enum {string}
 */
export enum MetricRequestDtoAggregationsEnum {
    Max = 'max',
    Min = 'min',
    Sum = 'sum',
    Avg = 'avg',
    Std = 'std',
    Count = 'count'
}

